module.exports = __webpack_public_path__ + "static/collaboration_smallBanner-52650369155c4a9769c8e5f83ea69478.png";